import React, { useState, useEffect, Fragment } from "react";
import Card from "olive-react-myoneui/lib/Card";
import Button from "olive-react-myoneui/lib/Button";
import WeekDropdown from "./utils/WeekDropdown";
import { leftArrow, rightArrow, calendarIcon, downArrowChevronIcon } from "../../constants/icons";
import DatePicker from "./utils/DatePicker";
import { getDays, getNextSet, getPreviousSet } from "./utils/utils";
import { openIdb } from "./utils/storageManager";
import { WeekCalender, MonthCalender } from "./utils/CalenderModes";
import axios from "axios";
import { calendarModuleName, idpUrl, nodeUrl, nodeUrlDev } from '../../constants/config';
import { useTranslation } from 'react-i18next';
import { setLangInCache } from '../../utils/helpers';
import { convertUTCtoLocalTime, getDateInFormat } from "../../helpers/dateTimeHelper";
import EventSlot from "./utils/EventSlot";
import Skeleton from "react-loading-skeleton";
import { EventLoader } from "./SkeLoader";

function MyKalendar({
  className,
  date = null,
  accessToken,
  uuid,
  accountId,
  idp,
  eventListCallback,
  mode,
  calenderKey,
  timeZone,
  language = 'en'
}) {
  const { t, i18n } = useTranslation(calendarModuleName);

  const langSet = (lang) => {
    i18n.changeLanguage(lang);
    setLangInCache(lang);
  };

  useEffect(() => {
    langSet(language);
  }, [language]);

  const { get, set } = openIdb(
    "mykalender",
    "events",
    1,
    typeof calenderKey !== "undefined" ? calenderKey : "myk"
  );
  const defaultYear = new Date().getFullYear(),
    defaultMonth = ("0" + (new Date().getMonth() + 1)).slice(-2),
    defaultDay = ("0" + new Date().getDate()).slice(-2);
  const [activeYear, setActiveYear] = useState(defaultYear);
  const [activeMonth, setActiveMonth] = useState(defaultMonth);
  const [activeDay, setActiveDay] = useState(defaultDay);
  const [frameEvents, setFrameEvents] = useState({});
  const [frameDays, setFrameDays] = useState({});
  const [calendarMode, setCalendarMode] = useState(mode || "week");
  const [changedDate, setChangedDate] = useState(
    date || defaultYear + "-" + defaultMonth + "-" + defaultDay
  );
  const [selectedDate, setSelectedDate] = useState(
    date ? new Date(date).toLocaleDateString() : new Date().toLocaleDateString()
  );
  const [loading, setLoading] = useState(true);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isViewAllEvents, setIsViewAllEvents] = useState(false);
  const [allEvents, setAllEvents] = useState({});

  const handleViewAllEventsClick = () => {
    setIsViewAllEvents(true); 
  };

  const handleBackToCalendarClick = () => {
    setIsViewAllEvents(false); 
  };

  useEffect(() => {
    let givenDate = changedDate;
    if (givenDate !== null) {
      givenDate = givenDate.replace("/", "-");
      givenDate = givenDate.split("-");
    }
    if (givenDate !== null && typeof givenDate[0] !== "undefined") {
      setActiveYear(givenDate[0]);
    }
    if (givenDate !== null && typeof givenDate[1] !== "undefined") {
      setActiveMonth(givenDate[1]);
    }
    if (givenDate !== null && typeof givenDate[2] !== "undefined") {
      setActiveDay(givenDate[2]);
    }
  }, [changedDate]);

  useEffect(() => {
    const init = async () => {
      setLoading(true);

      if(isViewAllEvents) {
        // Handle View All Events mode
        try {
          const startDate = '1900-01-01';
          const endDate = new Date();
          endDate.setMonth(endDate.getMonth() + 6);
          const formattedEndDate = endDate.toISOString().split('T')[0];
  
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          };
  
          const response = await axios.get(`https://${idp}/api/v1/events`, {
            headers,
            params: {
              method_name: "calendar",
              limit: 1000,
              page: 1,
              account_id: accountId,
              us_uuid: uuid,
              start_date: startDate,
              end_date: formattedEndDate,
              timezone: timeZone
            }
          });

          const allEventsData = response.data.data.result;
        // Convert to sorted array of [date, events] pairs
        const sortedEntries = Object.entries(allEventsData)
          .sort(([dateA], [dateB]) => 
            new Date(dateB) - new Date(dateA) // Reverse chronological sort
          );

        // Convert back to object (optional) or keep as array
        const sortedEvents = Object.fromEntries(sortedEntries);

        setAllEvents(sortedEvents);

      } catch (error) { 
        console.error('Error fetching all events:', error);
        setAllEvents({});
       }

        setLoading(false);
      } else {

      if (activeYear !== null && activeMonth !== null && activeDay !== null) {
        let frameDays = getDays(
          activeYear,
          activeMonth,
          activeDay,
          calendarMode
        );
        setFrameDays(frameDays.days);

        //  setting frame events with data we have in indexed DB
        let frameDates = frameDays.dates;
        let _frameEvents = {
          events: {},
          request: [],
        };
        var frameEventsCache = null;
        if (frameDates.length > 0) {
          for (let i = 0; i < frameDates.length; i++) {
            const eventDate = frameDates[i];
            frameEventsCache = await get(eventDate);
            if (
              typeof frameEventsCache === "undefined" ||
              frameEventsCache === null
            ) {
              _frameEvents.request.push(eventDate);
            } else {
              _frameEvents.events[eventDate] = frameEventsCache;
            }
          }
        }
        // End

        //Get frame events for missing date from callback and set it to the indexed DB
        if (_frameEvents.request.length > 0) {
          let obj = {
            days: _frameEvents.request,
            accessToken: accessToken,
            uuid: uuid,
            accountId: accountId,
            selectedDate: changedDate,
            calendarMode: calendarMode
          };

          //api starts

          let dbEvent = {};
          let events = {};
          let frameEventsFromServer = {};
          let host = window.location.protocol + '//' + window.location.host;
          if (accessToken) {
            const headers = {
              'Content-Type': 'application/json',
              // 'x-access-token' : 'NKNvNTNtNp7wNzNX7uNzNT7v7ZNjN'
              'Authorization': `Bearer ${accessToken}`
            }

            let limit = 31;
            let startDate = '';
            let endDate = '';
            if (calendarMode == 'week') {
              startDate = changedDate;
              endDate = changedDate;
            } else {
              if (obj.days.length > 0) {
                startDate = obj.days[0];
                endDate = obj.days[obj.days.length - 1];
              }
            }

            startDate = getDateInFormat(convertUTCtoLocalTime(startDate, timeZone), 'yyyy-mm-dd');
            endDate = getDateInFormat(convertUTCtoLocalTime(endDate, timeZone), 'yyyy-mm-dd');
            
            // axios.get(`${nodeUrl}events/calendar?limit=${limit}&page=1&account_id=${accountId}&us_uuid=${uuid}&start_date=${startDate}&end_date=${endDate}&timezone=${timeZone}`, {
            axios.get(`https://${idp}/api/v1/events?limit=${limit}&page=1&account_id=${accountId}&us_uuid=${uuid}&start_date=${startDate}&end_date=${endDate}&timezone=${timeZone}`, {
              headers,
              params: {
                "method_name": "calendar"
              }
            })
              .then((response) => {
                // console.log('calendar', response.data.result);
                // if(response?.data?.result?.length > 0){
                dbEvent = response.data.data.result;
                // setReminder(response.data.result.events)
                // }

                if (typeof obj.days !== "undefined") {
                  for (let i = 0; i < obj.days.length; i++) {
                    if (typeof dbEvent[obj.days[i]] !== "undefined") {
                      events[obj.days[i]] = dbEvent[obj.days[i]];
                    }
                  }
                }

                // return events;
                frameEventsFromServer = events;
                // console.log('frameeventsserver', frameEventsFromServer);
                if (Object.keys(frameEventsFromServer).length > 0) {
                  for (const [date, events] of Object.entries(
                    frameEventsFromServer
                  )) {
                    // _frameEvents.request = unsetArrayItem(date, _frameEvents.request);
                    set(date, events);
                    _frameEvents.events[date] = events;
                  }
                }

                var startNewDate = new Date(startDate);
                var endNewDate = new Date(endDate);
                var timeDifference = endNewDate - startNewDate;
                var daysDiff = timeDifference / (1000 * 3600 * 24);

                if (Object.keys(_frameEvents.events).length) {
                  if(Object.keys(_frameEvents.events)[0] === changedDate) {
                    setFrameEvents(_frameEvents.events);
                  }
                  if(daysDiff > 10) {
                    setFrameEvents(_frameEvents.events);
                  }
                  //setFrameEvents(_frameEvents.events);
                }
                setLoading(false);
              })
              .catch((error) => {
                // Error
                if (error.response) {
                  console.log('err1', error.response);
                } else if (error.request) {
                  console.log('err2', error.request);
                } else {
                  console.log('Error', error.message);
                }
                console.log(error.config);
                // return events;
              });

          } else {
            // return events;
            setLoading(false);
          }
        }
      }
     }
    };
    init();
  }, [isViewAllEvents, activeYear, activeMonth, activeDay, calendarMode]);

  

  const getNextSetInit = () => {
    let nextSet = getNextSet(activeYear, activeMonth, activeDay, calendarMode);
    handleListingDateChange(
      nextSet.getFullYear(),
      nextSet.getMonth(),
      nextSet.getDate(),
      true
    );
  };
  const getPreviousSetInit = () => {
    let previousSet = getPreviousSet(
      activeYear,
      activeMonth,
      activeDay,
      calendarMode
    );
    handleListingDateChange(
      previousSet.getFullYear(),
      previousSet.getMonth(),
      previousSet.getDate(),
      true
    );
  };

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const changeCalendarMode = (mode) => {
    if (isViewAllEvents) {
      setIsViewAllEvents(false);
    }
    setCalendarMode(mode);
  };
  const handleCalenderDateChange = (newDate) => {
    let givenDate = newDate.split("-");
    handleListingDateChange(givenDate[0], parseInt(givenDate[1]) - 1, parseInt(givenDate[2]));
  };
  const handleListingDateChange = (year, month, day, nextFlag = false) => {
    let changedDate = new Date(year, month, day);
    setSelectedDate(changedDate.toLocaleDateString());
    setChangedDate(
      changedDate.getFullYear() +
      "-" +
      ("0" + (changedDate.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + changedDate.getDate()).slice(-2)
    );
    if (!nextFlag)
      changeCalendarMode('week');
  };

  return (
    <>
      <Card className={`${className || ""} myk_stu-calendar-wrapper bg-transparent border-0`}>
        <Card.Body className="p-0">
          <Card.Header className="d-flex align-items-center justify-content-between mb-3 px-1">
            <div className="date-picker event-date-picker d-flex align-items-center gap-2 arrow-sm-wrap">
              {calendarIcon}
              <DatePicker
                onChange={handleCalenderDateChange}
                year={activeYear}
                month={activeMonth}
                day={activeDay}
              />
              {downArrowChevronIcon}
              <div className="arrow-actions arrow-sm-action">
                <a href={void (0)}  onClick={() => getPreviousSetInit()} className="btn-move btn-prev cursor">
                  {leftArrow}
                </a>{" "}
                <a href={void (0)} onClick={() => getNextSetInit()} className="btn-move btn-next">
                  {rightArrow}
                </a>
              </div>
            </div>
            <div className="date-period-arrow-actions d-flex align-items-center gap-2">
              {!isViewAllEvents && (
                <Button variant="outline" className="btn-sm d-flex align-items-center gap-2 bg-transparent btn-myk-view_all_events" onClick={handleViewAllEventsClick}>
                  {screenWidth > 1400 ? (
                    <>
                      View all Events
                    </>
                  ) : (
                    'All Events'
                  )}
                </Button>
              )}
              {isViewAllEvents &&
              <Button variant="outline" className="btn-sm d-flex align-items-center gap-2 bg-transparent btn-myk-back_calendar" onClick={handleBackToCalendarClick}>
                  <>
                  {leftArrow} Back {screenWidth > 575 ? ('to Calendar' ):('')}
                  </>
              </Button>
              }
              <div className="arrow-actions arrow-lg-action">
                <a
                  href={void (0)}
                  className="btn-move btn-prev"
                  onClick={() => getPreviousSetInit()}
                >
                  {leftArrow}
                </a>{" "}
                <a
                  href={void (0)}
                  onClick={() => getNextSetInit()}
                  className="btn-move btn-next"
                >
                  {rightArrow}
                </a>
              </div>
              <div className="date-period">
                <WeekDropdown
                  mode={t(calendarMode)}
                  onChange={(mode) => {changeCalendarMode(mode)}}
                />
              </div>
            </div>
          </Card.Header>
          {!isViewAllEvents && (
          <>
          {calendarMode == "week" && (
          loading ?
          <> 
            <div className="days-list mb-3 d-block">
              <Skeleton height={"48px"}/>
            </div>
            <span className="card-divider my-3" />
            <div className="eventlist-wrapper rounded">
              <EventLoader items={2}/>
            </div>
          </>
          : (
            <WeekCalender
              {...{
                frameDays: frameDays,
                frameEvents: frameEvents,
                selectedDate: selectedDate,
                changedDate: changedDate,
                handleListingDateChange: handleListingDateChange,
                timeZone: timeZone
              }}
            />
          ))}
          {calendarMode == "month" && (
            loading ?
            <> 
              <div className="days-list mb-3 d-block">
                <Skeleton height={"45px"} style={{marginBottom: "10px"}}/>
                <Skeleton height={"245px"}/>
              </div>
              <div className="eventlist-wrapper rounded">
                <Skeleton width={"100px"} height={"15px"} style={{marginBottom: "10px"}}/>
                <EventLoader items={2}/>
              </div>
            </>
            : (
            <MonthCalender
              {...{
                frameDays: frameDays,
                frameEvents: frameEvents,
                selectedDate: selectedDate,
                handleListingDateChange: handleListingDateChange,
                timeZone: timeZone,
                isMonthCalendarShown:true
              }}
            />
            ))}
          </>
          )}
          {isViewAllEvents &&
          <div className={`eventlist-wrapper eventlist-month-wrapper only-events`}>
            {loading ? (
              <div className="d">
                <h5 className="eventlist-heading">All the events</h5>
                <EventLoader items={5}/>
              </div>
            ) : Object.values(allEvents).some(events => events.length > 0) ? (
              <>
                <h5 className="eventlist-heading">All the events</h5>
                <div className="eventlist-all">
                {Object.entries(allEvents).map(([date, events], index) => (
                  <div key={`month_event_${index}`} className="eventlist-date-group">
                    {events.map((event, idx) => (
                      <EventSlot
                        key={`event_all_${index}_${idx}`}
                        className="mb-3"
                        event={event}
                        timeZone={timeZone}
                      />
                    ))}
                  </div>
                ))}
                </div>
              </>
            ) : (
              <Card className="empty-block-card">
                <Card.Body className="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
                  <div className="empty-block">
                    <h6><strong>{t("No Events Found!")}</strong></h6>
                    <p className="mb-0">{t("Once admin assign events, it will show up here.")}</p>
                  </div>
                </Card.Body>
              </Card>
            )}
            </div>
          }
        </Card.Body>
      </Card>
    </>
  );
}

export default React.memo(MyKalendar);
